import { fetchWebsite } from '../utils/api/website.utils';
import { WebsiteConfiguration } from './UserWebsite';
import { WebsiteState } from './website.types';

export class Theme {
  public id: string;
  public title: string;
  public category: string;
  public draft: WebsiteConfiguration;
  public published: WebsiteConfiguration;

  constructor(params: {
    id: string;
    title: string;
    category: string;
    draft: WebsiteConfiguration;
    published: WebsiteConfiguration;
  }) {
    this.id = params.id;
    this.title = params.title;
    this.category = params.category;
    this.draft = params.draft;
    this.published = params.published;
  }

  static async fromId(themeId: string): Promise<Theme> {
    return (await fetchWebsite(themeId, 'theme')) as Theme;
  }

  getHtml(websiteState: WebsiteState, pageIndex: number = 0): string {
    return this[websiteState ?? 'published'].pages[pageIndex]?.html ?? '';
  }
}
